import { Theme } from "@allaria-tech/matter/ThemeProvider";
import { OnboardingTheme } from "../types";

// The Allaria palette is Matter's default, so it overrides nothing.
const ALLARIA: Theme = {};

const DIGITAL: Theme = {
  ...ALLARIA,
  fontFamily: '"Open Sans", sans-serif',
  primary50: "#ebf5fb",
  primary100: "#d6eaf8",
  primary200: "#aed6f1",
  primary300: "#3498da",
  primary400: "#2e86c1",
  primary500: "#2874a6",
  primary600: "#21618c",
  secondary300: "#8690a1",
  secondary500: "#3a506b",
  neutrals400: "#acb3bf",
  neutrals600: "#001c40",
  info50: "#e8f1f8",
};

const SAV3: Theme = {
  primary50: "#f6f3fa",
  primary100: "#e6dff4",
  primary200: "#ad98e7",
  primary300: "#7552db",
  primary400: "#6849c3",
  primary500: "#553ca0",
  primary600: "#402d78",
  fontFamily: "Geist, sans-serif",
};

export const themeVariables: Record<OnboardingTheme, Theme> = {
  ALLARIA,
  DIGITAL,
  SAV3,
};
